import { createContext } from "react";

export const DayjsContext = createContext();
